<template>
  <div>
    <div v-if="!question.isVoterEligible">
      <h1 class="headline">Skipping: {{ question.header }}</h1>
      <p>
        We're skipping this step because voting on this matter is limited to
        <b>{{ subgroupsFormatted }}.</b>
      </p>

      <p>Please click on the "Next" button to continue.</p>
    </div>
    <div v-else>
      <h1 class="headline">{{ headerText }}</h1>
      <p v-html="snippetText"></p>
      <p v-if="downloadLink">
        <a target="_blank" :href="downloadLink">Click here</a>
        to view additonal information.
      </p>
      <p>
        Select one or more directors to vote for their removal. To proceed
        without voting, click 'Next Step' to continue.
      </p>

      <!-- Toggle List -->
      <div class="toggle-list mdl-shadow--2dp">
        <div v-for="(candidate, index) in directors" v-cloak :key="candidate">
          <removal-toggle-list-item
            :value="candidate"
            icon="account_circle"
            toggle-icon="close"
            :index="index"
            :text="candidate"
            :checked-status="
              voteSelection.indexOf(candidate) >= 0 ? true : false
            "
            toggle-class="toggle-content-action"
            @inputting="updateSelection"
          />
        </div>
      </div>
    </div>

    <div class="App-buttons">
      <question-button></question-button>
    </div>
  </div>
</template>

<script>
import QuestionButton from '@/components/Questions/QuestionsButton';
import RemovalToggleListItem from './RemovalToggleListItem';

import {mapActions} from 'vuex';

import {subgroups} from '@/vuex/helpers.js';

export default {
  name: 'DirectorRemovals',
  props: {
    question: {
      type: Object,
      required: true
    },
    questionId: {
      type: [Number, String],
      required: true
    }
  },
  components: {
    QuestionButton,
    RemovalToggleListItem
  },
  computed: {
    isDisabled() {
      return false;
    },
    icon() {
      return this.question.icon ? this.question.icon : 'thumbs_up_down';
    },
    downloadLink() {
      return this.question.url ? this.question.url : '';
    },
    headerText() {
      return this.question.header
        ? this.question.header
        : 'Removal of Directors from the Corporation Board';
    },
    snippetText() {
      return this.question.snippet
        ? this.question.snippet
        : 'A requisition has been made to vote on the removal of directors from the board. The current directors are listed below.';
    },
    directors() {
      return this.question.options;
    },
    voteSelection() {
      return this.question.vote.selection.filter(Boolean);
    },
    subgroupsFormatted() {
      return subgroups(this.question);
    }
  },
  methods: {
    ...mapActions('questions', ['updateVote']),

    // Updates the vote selection in Vuex
    updateSelection(candidate) {
      let index = this.voteList.indexOf(candidate);
      if (index >= 0) {
        this.voteList.splice(index, 1);
      } else {
        this.voteList.push(candidate);
      }

      // If array is empty, insert empty string in array
      // Required for API to interpret abstain vote
      if (this.voteList.length === 0) {
        this.updateVote({
          questionId: this.questionId,
          vote: ['']
        });
      } else {
        this.updateVote({
          questionId: this.questionId,
          vote: this.voteList
        });
      }
    }
  },
  data() {
    return {
      voteList: []
    };
  },
  created() {
    this.voteList = this.voteSelection;
  }
};
</script>

<style scoped></style>
